module.exports = __webpack_public_path__ + "img/time_6.0c310974.png";